var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufacturing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 19.023c0-.735-.737-1.23-1.398-.938l-28 12.403a1.026 1.026 0 0 0-.602.939v9.55c0 .565.448 1.023 1 1.023h25c2.21 0 4-1.83 4-4.089V19.023Z",
    fill: "#FBB945"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14.018c0-.722-.719-1.214-1.376-.942l-30 12.394a1.017 1.017 0 0 0-.624.943v14.57c0 .562.448 1.017 1 1.017h27c2.21 0 4-1.821 4-4.068V14.018Z",
    fill: "#FC868B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m42 21.01-21.398 9.478c-.365.162-.602.53-.602.938v9.552c0 .564.448 1.022 1 1.022h17c2.21 0 4-1.822 4-4.068V21.01Z",
    fill: "#F86126"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 9.015c0-.72-.719-1.21-1.376-.94l-30 12.364a1.015 1.015 0 0 0-.624.94v19.607C0 41.546.448 42 1 42h27c2.21 0 4-1.817 4-4.058V9.015Z",
    fill: "#1AD3BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.639 10.624 25.47a1.017 1.017 0 0 0-.624.943v14.57c0 .562.448 1.017 1 1.017h17c2.21 0 4-1.817 4-4.058V16.64Z",
    fill: "#1A6F66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturing);
export default __webpack_public_path__ + "static/media/Manufacturing.ce8775212a7b898da15bfab945a72388.svg";
export { ForwardRef as ReactComponent };